import request from '@/utils/request'
const BASE_URL = '/StOtherInDoc'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'get',
      params: { id }
    })
  },
  examine(id) {
    return request({
      url: BASE_URL + '/Examine',
      method: 'get',
      params: { id }
    })
  },
  cancelExamine(id) {
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  getGoodsList(id) {
    return request({
      url: BASE_URL + '/GetGoodsList',
      method: 'get',
      params: { id }
    })
  },
}